// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesList-cls1_X93","cls2":"SavedReferencesList-cls2_8ky SavedReferencesList-cls1_X93"};